<h4 class="p-2 pl-4 mb-4 text-white" mat-dialog-title>&nbsp;{{data.title}}</h4>
<mat-dialog-content class="pb-2">
    <p>{{translate.getLng('IMPORT_SEARCH_PLACEHOLDER')}} <br><span
            class="sen-fs10">({{translate.getLng('IMPORT_SEARCH_INFO')}})</span></p>
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <mat-form-field fxFlex="1 1 auto">
            <mat-label>{{translate.getLng('SEARCH')}}</mat-label>
            <input matInput senAppSearchDelay (delayedInput)="planSearchCall($event)">
        </mat-form-field>

        <!-- <mat-form-field fxFlex="1 1 20%" class="mx-3">
            <mat-select formControlName="search">
                <mat-option value="{{translate.getLng('PLAN')}}">{{translate.getLng('PLAN')}}</mat-option>
                <mat-option value="{{translate.getLng('PROJECT')}}">{{translate.getLng('PROJECT')}}</mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-icon>search</mat-icon>
    </div>
    <mat-card (click)="importPlanSelect(plan)" class="p-2 mt-2 sen-cursor-pointer sen-light-blue-bg" fxLayout="row"
        fxLayoutAlign="space-between center" *ngFor="let plan of planSearchResults">
        <mat-radio-button [checked]="selectedPlanImport && selectedPlanImport.id == plan.id" class="example-margin"
            fxFlex="1 1 10%">
        </mat-radio-button>
        <div fxFlex="1 1 auto">
            <div fxLayout="row">
                <input matInput (input)="importPlanSelect(plan)" [(ngModel)]="plan.name"
                    class="border-bottom border-dark mb-2">
                <mat-icon matTooltipClass="sen-snackbar-color"
                    matTooltip="{{translate.getLng('EXISTING_PLAN_NAME_WARNING')}}" class="sen-fs16 sen-valign-sub"
                    *ngIf="plan.duplicate" color="invalid">
                    warning</mat-icon>
            </div>
            <div class="sen-fs10" title="{{plan.projectName}}">{{translate.getLng('PROJECT_NAME')}}:
                {{plan.projectName | truncate: 25}}</div>
        </div>
        <p class="ml-2 mb-0" fxFlex="1 1 20%">{{translate.getLng('ID')}} : {{plan.id}}<br>
            <label class="sen-fs10" *ngIf="plan.updated">{{translate.getLng('UPDATED_DATE_STRING')}} :
                {{plan.updated}}</label>
        </p>
    </mat-card>
</mat-dialog-content>
<mat-dialog-actions class="text-center mt-4 justify-content-center">
    <button mat-raised-button class="px-5 py-2" (click)="closeDialogue(false)">{{data.buttons.cancel}}</button>
    <button mat-raised-button color="primary" class="px-5 py-2"
        [disabled]="!selectedPlanImport || !selectedPlanImport.name || selectedPlanImport.duplicate"
        (click)="closeDialogue(true)">{{data.buttons.import}}</button>
</mat-dialog-actions>